
module.exports = {"attributes":{"width":"54","height":"40"},"content":"<path d=\"M0 40h21v-1l-5.4-1.6V0h-4.3L.1 5.4v1.3l5.5-1.4v32.1L0 39.1zm37 0c-9.2 0-17-6.8-17-19.8C20 6.6 28.1 0 37.3 0 46.4 0 54 6.5 54 19.9 54 33.3 46.3 40 37 40zm.1-1c4 0 5.2-6.1 5.2-18.7C42.3 7 41 1.1 37.1 1.1c-4 0-5.4 6-5.4 18.7 0 13 1.4 19.1 5.4 19.1z\"/>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
